import React from 'react';
import DOMPurify from 'dompurify';

// Remove scripts, handlers inline (onerror, onclick...) e URLs javascript: do HTML vindo da API.
export const sanitizeHtml = (htmlString) =>
  DOMPurify.sanitize(htmlString, { USE_PROFILES: { html: true } });

const HtmlRenderer = ({ htmlString }) => {
  if (!htmlString || typeof htmlString !== 'string') {
    return null;
  }

  return <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(htmlString) }} />;
};

export default HtmlRenderer;
